import { QueryParams } from '@/model';
import apiClient from '../api/apiClient';
import { buildApiUrl } from '../utils';
import { GetAccessControlUserByIdResponse, GetAccessControlUserResponse, GetPermissionTypeByIdResponse, GetPermissionTypesResponse } from '../response/access-control';
import { CreateAccessControlUserPayload, CreatePermissionTypePayload, UpdateAccessControlUserPayload } from '../request/access-control';

export class AccessControlService {
  static getPermissionTypes(params?: QueryParams) {
    return apiClient.get<GetPermissionTypesResponse>(buildApiUrl('/api/v1/administrator/access-control/permission-types'), params);
  }

  static createPermissionType(payload: CreatePermissionTypePayload) {
    return apiClient.post<void>(buildApiUrl('/api/v1/administrator/access-control/permission-types/new'), payload);
  }

  static getPermissionTypeById(id: string) {
    return apiClient.get<GetPermissionTypeByIdResponse>(buildApiUrl('/api/v1/administrator/access-control/permission-types/:id'), id);
  }

  static updatePermissionType(id: string, payload: CreatePermissionTypePayload) {
    return apiClient.update<void>(buildApiUrl('/api/v1/administrator/access-control/permission-types/:id', { id }), payload);
  }

  static getUsers(params?: QueryParams) {
    return apiClient.get<GetAccessControlUserResponse>(buildApiUrl('/api/v1/administrator/access-control/users'), params);
  }

  static createUser(payload: CreateAccessControlUserPayload) {
    return apiClient.post<void>(buildApiUrl('/api/v1/administrator/access-control/users/new'), payload);
  }

  static getUserById(id: string) {
    return apiClient.get<GetAccessControlUserByIdResponse>(buildApiUrl('/api/v1/administrator/access-control/users/:id'), id);
  }

  static updateUser(id: string, payload: UpdateAccessControlUserPayload) {
    return apiClient.update<void>(buildApiUrl('/api/v1/administrator/access-control/users/:id', { id }), payload);
  }

  static blockUser(id: string) {
    return apiClient.update<void>(buildApiUrl('/api/v1/administrator/access-control/users/:id/block', { id }));
  }

  static unblockUser(id: string) {
    return apiClient.update<void>(buildApiUrl('/api/v1/administrator/access-control/users/:id/unblock', { id }));
  }
}
